"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _every2 = _interopRequireDefault(require("lodash/every"));

var Styled = _interopRequireWildcard(require("./VideoPlayer.style"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ratioToPercentage = function ratioToPercentage(ratio) {
  var splitRatio = ratio.split(':');
  var ratioIsValid = splitRatio && splitRatio.length === 2 && (0, _every2.default)(splitRatio, String);
  return ratioIsValid ? (Number(splitRatio[1]) / Number(splitRatio[0]) * 100).toFixed(2) + "%" : null;
};

var defaultRatio = '16:9';
var defaultPercentage = ratioToPercentage(defaultRatio);

var getPercentage = function getPercentage(ratio) {
  var operator = ratio.match('[:%]') && ratio.match('[:%]')[0] || null;

  switch (operator) {
    case ':':
      return ratioToPercentage(ratio) || defaultPercentage;

    case '%':
      return ratio;

    default:
      return defaultPercentage;
  }
};

var VideoPlayer = function VideoPlayer(_a) {
  var _b = _a.ratio,
      ratio = _b === void 0 ? defaultRatio : _b,
      className = _a.className,
      props = (0, _tslib.__rest)(_a, ["ratio", "className"]);
  return _react.default.createElement(Styled.VideoPlayer, {
    pt: getPercentage(ratio),
    className: className
  }, _react.default.createElement(Styled.Player, (0, _tslib.__assign)({
    width: "100%",
    height: "100%"
  }, props)));
};

var _default = VideoPlayer;
exports.default = _default;